import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';
import InnerContent from './InnerContent/InnerContent';

export type PartnerPagesListProps =
  SliceComponentProps<Content.PartnerPagesListSlice>;

const PartnerPagesList = ({ slice }: PartnerPagesListProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      <div className={styles.container}>
        <div className={styles.title}>
          <PrismicRichText field={slice.primary.title} />
        </div>
        <InnerContent data={slice.primary.slides} />
        <div className={styles.firstEllipse} />
        <div className={styles.secondEllipse} />
      </div>
    </section>
  );
};

export default PartnerPagesList;
